import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

export type alertType = 'danger' | 'info' | 'success';
export interface AlertMessage {
  message: string;
  type: alertType;
}

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  imports: [NgbAlertModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
  readonly message = input<string>();
  readonly type = input<'danger' | 'info' | 'success'>();
  readonly dismissible = input<boolean>();
}
